import styled from "styled-components";
import { colorPalette, fonts, typeScale } from "../../utils/theme";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isClosing",
})<{ isClosing: boolean }>`
  background-color: ${colorPalette.white};
  border-radius: 8px;
  width: auto;
  z-index: 10000;
  padding-bottom: var(--safe-area-inset-bottom);

  /* Apply min-width only on larger screens */
  @media (min-width: 768px) {
    max-width: 700px;
  }

  /* Mobile-specific styles for bottom modal sheet */
  @media (max-width: 767.98px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 80vh;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    animation: ${({ isClosing }) =>
      isClosing ? "slideDown 0.3s ease-out" : "slideUp 0.3s ease-out"};

    @keyframes slideUp {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }

    @keyframes slideDown {
      from {
        transform: translateY(0);
      }
      to {
        transform: translateY(100%);
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: start;
  padding: 16px;
  border-bottom: 1px solid ${colorPalette.blue100};
`;

export const HeaderTitle = styled.h2`
  margin: 0;
  color: ${colorPalette.primaryDark};
  ${typeScale.headingXSMain}
`;

export const HeaderSubtitle = styled.p`
  margin: 0;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXSMain}
`;

export const ModalBody = styled.div`
  text-align: start;
  overflow-y: auto;
  max-height: 70vh;

  /* Apply max-height only on larger screens */
  @media (min-width: 768px) {
    max-height: 600px;
  }
`;

export const ContentWrapper = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 16px;

  p {
    color: ${colorPalette.textDark};
    ${typeScale.bodyXXS};
  }

  @media (max-width: 767.98px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

/* TABLE */
export const ComparisonTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: white;

    th {
      padding-top: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid ${colorPalette.blue100};
      color: ${colorPalette.primaryDark};
      ${typeScale.headingXXSMain};
      width: 40%; /* First column (Leistung) */
      &:nth-child(2),
      &:nth-child(3) {
        width: 30%; /* Second and third columns (Basic, Premium) */
      }
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid ${colorPalette.blue100};
    }
  }
`;

export const ComparisonCell = styled.td`
  vertical-align: top;
  padding-top: 12px;
  padding-bottom: 12px;
  width: 90%; /* Default for first column */
  &:nth-child(2),
  &:nth-child(3) {
    width: 5%; /* Second and third columns */
  }

  strong {
    display: block;
    margin-bottom: 4px;
    color: ${colorPalette.primaryDark};
    ${typeScale.headingXXSMain};
  }
`;

export const Description = styled.p`
  margin-bottom: 4px;
  color: ${colorPalette.textMain} !important;
  font-size: "0.75rem" !important;
  font-weight: 700 !important;
  line-height: 1.4 !important;
  font-family: ${fonts.primary} !important;
`;

export const Optional = styled.p`
  margin: 0;
  color: ${colorPalette.textDark} !important;
  font-size: "0.625rem" !important;
  font-weight: 500 !important;
  line-height: 1.2 !important;
  font-family: ${fonts.primary} !important;
`;

export const ComparisonRow = styled.tr`
  &:first-child td {
    padding-top: 16px;
  }
`;
